// import { getCssScale } from "../Helper/helper";

/*
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */

export let DataActionController = {
  zoom: function (data) {
    document.addEventListener("mouseup", this.zoommouseup, false);
    document.addEventListener("touchend", this.zoommouseup, false);

    if (data === "in") {
      this.SetIntv = setInterval(function () {
        DrawingController.zoomIn();
      }, 16);
    } else if (data === "out") {
      this.SetIntv = setInterval(function () {
        DrawingController.zoomOut();
      }, 16);
    }
  },
  zoomwheel: function (data, event) {
    if (data === "in") {
      DrawingController.zoomIn(event);
    } else if (data === "out") {
      DrawingController.zoomOut(event);
    }
  },
  zoommouseup: function () {
    clearInterval(DataActionController.SetIntv);
    document.removeEventListener(
      "mouseup",
      DataActionController.zoommouseup,
      false
    );
    document.removeEventListener(
      "touchend",
      DataActionController.zoommouseup,
      false
    );
  },
  pan: function (data) {
    document.addEventListener("mouseup", this.panmouseup, false);
    document.addEventListener("touchend", this.panmouseup, false);
    if (data === "up") {
      this.SetIntv = setInterval(function () {
        DrawingController.panUp();
      }, 16);
    } else if (data === "down") {
      this.SetIntv = setInterval(function () {
        DrawingController.panDown();
      }, 16);
    } else if (data === "left") {
      this.SetIntv = setInterval(function () {
        DrawingController.panLeft();
      }, 16);
    } else if (data === "right") {
      this.SetIntv = setInterval(function () {
        DrawingController.panRight();
      }, 16);
    }
  },
  panmouseup: function () {
    clearInterval(this.SetIntv);
    document.removeEventListener("mouseup", this.panmouseup, false);
    document.removeEventListener("touchend", this.panmouseup, false);
  },
  drag: function (event) {
    let pageX = null;
    let pageY = null;
    const EH = window.EventHandler;
    const DC = window.DrawingController;
    const FV = window.FloorplanView;

    if (EH.pinched == true) return;

    if (event.type == "touchmove") {
      pageX = event.touches[0].pageX;
      pageY = event.touches[0].pageY;
    } else {
      pageX = event.pageX;
      pageY = event.pageY;
    }

    EH.dragMovedX = EH.dragStartX - pageX;
    EH.dragMovedY = EH.dragStartY - pageY;

    if (parseInt(EH.dragStartX) == pageX) return; // fix small click bug

    // disable pagescrolling on mobile devices
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    EH.mousemoved = true;
    FV.closePopup();

    const moveToX =
      parseInt(DC.svgDragStartX) - parseInt(EH.dragStartX) + pageX;
    const moveToY =
      parseInt(DC.svgDragStartY) - parseInt(EH.dragStartY) + pageY;

    // const zoom = getCssScale(window.DrawingController.svg);
    const svgWrapper = DC.svgWrapper;
    const zoom = svgWrapper.getAttribute("data-zoomlevel");

    DC.moveAndZoom(moveToX, moveToY, zoom);

    return false;
  },
};
